export default __webpack_public_path__ + "static/media/coins-solid.11292b56.svg";